import React, { Component } from 'react'
import Parent from './Parent'
import Loading from './Loading'
import PropTypes from 'prop-types'
export default class ParentsInformation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      prefixData: [],
      fatherPrefixData: [],
      motherPrefixData: [],
      fatherPrefix: '',
      motherPrefix: '',
      fatherFName: this.props.fatherInfo.RelationFirstName || '',
      motherFName: this.props.motherInfo.RelationFirstName || '',
      fatherMName: this.props.fatherInfo.RelationMiddleName || '',
      motherMName: this.props.motherInfo.RelationMiddleName || '',
      fatherLName: this.props.fatherInfo.RelationLastName || '',
      motherLName: this.props.motherInfo.RelationLastName || '',
      fatherProfession: this.props.fatherInfo.Profession || '',
      motherProfession: this.props.motherInfo.Profession || '',
      fatherCompany: this.props.fatherInfo.Company || '',
      motherCompany: this.props.motherInfo.Company || '',
      fatherCompanyAddress: this.props.fatherInfo.CompanyAddress || '',
      motherCompanyAddress: this.props.motherInfo.CompanyAddress || '',
      fatherPhone: this.props.fatherInfo.MobileNumber || '',
      motherPhone: this.props.motherInfo.MobileNumber || '',
      fatherEmail: this.props.fatherInfo.RelationEmail || '',
      motherEmail: this.props.motherInfo.RelationEmail || '',
      fatherAddress: this.props.fatherInfo.Address || '',
      motherAddress: this.props.motherInfo.Address || '',
      loading: true,
      motherAttendedInstitution: this.props.motherInfo.AttendedInstitution || false,
      fatherAttendedInstitution: this.props.fatherInfo.AttendedInstitution || false,
      error: '',
      fatherDeceased: this.props.fatherInfo.Deceased || false,
      motherDeceased: this.props.motherInfo.Deceased || false,
      isFatherEmployee:this.props.fatherInfo.IsTKHEmployee || false,
      isMotherEmployee:this.props.motherInfo.IsTKHEmployee || false,
      fatherIdNumber: this.props.fatherInfo.IdNumber||'',
      motherIdNumber: this.props.motherInfo.IdNumber||'',
    }
  }

  componentDidMount () {

    fetch(`${process.env.REACT_APP_API_URL}/api/parentinformation/getprefixes`)
      .then(res => res.json())
      .then(res => {
        if (res.length) {
          const avoidFPrefix = ['Miss', 'Ms.', 'Mrs.', 'Assistent']
          const avoidMPrefix = ['Mr.', 'Assistent']
          const fatherPrefix = res.filter(ele => avoidFPrefix.indexOf(ele.value) === -1)
          const mr = res.filter(ele => ele.value === 'Mr.')
          const mrId = mr && mr.length > 0 ? mr[0].Id : ''
          const mrs = res.filter(ele => ele.value === 'Mrs.')
          const mrsId = mrs && mrs.length > 0 ? mrs[0].Id : ''
          const motherPrefix = res.filter(ele => avoidMPrefix.indexOf(ele.value) === -1)
          this.setState({ fatherPrefixData: fatherPrefix, motherPrefixData: motherPrefix })
          this.props.getDefaultValue('Parent', {
            motherDefault: parseInt(this.props.motherInfo.RelationPrefix) || mrsId,
            fatherDefault: parseInt(this.props.fatherInfo.RelationPrefix) || mrId
          })
          this.setState({ motherPrefix: parseInt(this.props.motherInfo.RelationPrefix) || mrsId, fatherPrefix: parseInt(this.props.fatherInfo.RelationPrefix) || mrId, loading: false })
        }
      })
  }

  render () {
    
    const validationError = this.props.error
    const {
      fatherPrefixData,
      motherPrefixData,
      fatherPrefix,
      motherPrefix,
      fatherFName,
      motherFName,
      fatherMName,
      motherMName,
      fatherLName,
      motherLName,
      fatherProfession,
      motherProfession,
      fatherCompany,
      motherCompany,
      fatherCompanyAddress,
      motherCompanyAddress,
      fatherPhone,
      motherPhone,
      fatherEmail,
      motherEmail,
      fatherAddress,
      motherAddress,
      fatherAttendedInstitution,
      motherAttendedInstitution,
      loading,
      fatherDeceased,
      motherDeceased,
      isFatherEmployee,
      isMotherEmployee,
      fatherIdNumber,
      motherIdNumber,
      error
    } = this.state
    if (loading) {
      return (<Loading />)
    }
    return (
      <div>
        <p style={{ color: 'red' }}>{error}</p>
        <div className="father">
          Father&apos;s Information:
          <Parent
            guardian={false}
            relationshipData={[{ Id: this.props.fatherId, value: 'Father' }]}
            relationship={this.props.fatherId}
            deceasedOption={true}
            deceased={fatherDeceased}
            deceasedChange={() => {
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: !fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
              this.setState(prevState => ({ fatherDeceased: !prevState.fatherDeceased }))
            }
            }
            disabled={true}
            prefixData={fatherPrefixData}
            onChangePrefix={(val) => {
              this.setState({ fatherPrefix: val })
              this.props.collectState('PSI', {
                fatherPrefix: val,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            selectedPrefix={fatherPrefix}
            fName={fatherFName}
            onChangeFName={(val) => {
              this.setState({ fatherFName: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: val,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            mName={fatherMName}
            onChangeMName={(val) => {
              this.setState({ fatherMName: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: val,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            lName={fatherLName}
            onChangeLName={(val) => {
              this.setState({ fatherLName: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: val,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            profession={fatherProfession}
            onChangeProfession={(val) => {
              this.setState({ fatherProfession: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: val,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            company={fatherCompany}
            onChangeCompany={(val) => {
              this.setState({ fatherCompany: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: val,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            companyAddress={fatherCompanyAddress}
            onChangeCompanyAddress={(val) => {
              this.setState({ fatherCompanyAddress: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: val,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            mobileNumber={fatherPhone}
            onChangeNumber={(val) => {
              this.setState({ fatherPhone: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: val,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            email={fatherEmail}
            emailRequired={false}
            onChangeEmail={(val) => {
              this.setState({ fatherEmail: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: val,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            address={fatherAddress}
            onChangeAddress={(val) => {
              this.setState({ fatherAddress: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: val,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}



            
            isTKHEmployee={isFatherEmployee}
            onChangeIsTKHEmployee={(val) => {
              this.setState({ isFatherEmployee: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:val,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}

            idnumber={fatherIdNumber}
            onChangeIdNumber={(val) => {
              this.setState({ fatherIdNumber: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:val,
                motherIdNumber:motherIdNumber
              })
            }}




            disableAll={false}
            errRelation=""
            errPrefix={validationError.fatherPrefix ? validationError.fatherPrefix : ''}
            errFName={validationError.fatherFName ? validationError.fatherFName : ''}
            errMName={validationError.fatherMName ? validationError.fatherMName : ''}
            errLName={validationError.fatherLName ? validationError.fatherLName : ''}
            errProfession={validationError.fatherProfession ? validationError.fatherProfession : ''}
            errMobile={validationError.fatherPhone ? validationError.fatherPhone : ''}
            errEmail={validationError.fatherEmail ? validationError.fatherEmail : ''}
            errIdNumber={validationError.fatherIdNumber ? validationError.fatherIdNumber : ''}
          />
    
        </div>
        <div className="mother">
          Mother&apos;s Information:
          <Parent
            guardian={false}
            relationshipData={[{ Id: this.props.motherId, value: 'Mother' }]}
            relationship={this.props.motherId}
            disabled={true}
            deceasedOption={true}
            deceased={motherDeceased}
            deceasedChange={() => {
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: !motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
              this.setState(prevState => ({ motherDeceased: !prevState.motherDeceased }))
            }}
            prefixData={motherPrefixData}
            onChangePrefix={(val) => {
              this.setState({ motherPrefix: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: val,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            selectedPrefix={motherPrefix}
            fName={motherFName}
            onChangeFName={(val) => {
              this.setState({ motherFName: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: val,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            mName={motherMName}
            onChangeMName={(val) => {
              this.setState({ motherMName: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: val,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            lName={motherLName}
            onChangeLName={(val) => {
              this.setState({ motherLName: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: val,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            profession={motherProfession}
            onChangeProfession={(val) => {
              this.setState({ motherProfession: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: val,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            company={motherCompany}
            onChangeCompany={(val) => {
              this.setState({ motherCompany: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: val,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            companyAddress={motherCompanyAddress}
            onChangeCompanyAddress={(val) => {
              this.setState({ motherCompanyAddress: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: val,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            mobileNumber={motherPhone}
            onChangeNumber={(val) => {
              this.setState({ motherPhone: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: val,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            email={motherEmail}
            emailRequired={false}
            onChangeEmail={(val) => {
              this.setState({ motherEmail: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: val,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}
            address={motherAddress}
            onChangeAddress={(val) => {
              this.setState({ motherAddress: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: val,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}

            isTKHEmployee={isMotherEmployee}
            onChangeIsTKHEmployee={(val) => {
              this.setState({ isMotherEmployee: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:val,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:motherIdNumber
              })
            }}

            idnumber={motherIdNumber}
            onChangeIdNumber={(val) => {
              this.setState({ motherIdNumber: val })
              this.props.collectState('PSI', {
                fatherPrefix: fatherPrefix,
                motherPrefix: motherPrefix,
                fatherRelation: this.props.fatherId,
                motherRelation: this.props.motherId,
                fatherFName: fatherFName,
                motherFName: motherFName,
                fatherMName: fatherMName,
                motherMName: motherMName,
                fatherLName: fatherLName,
                motherLName: motherLName,
                fatherProfession: fatherProfession,
                motherProfession: motherProfession,
                fatherCompany: fatherCompany,
                motherCompany: motherCompany,
                fatherCompanyAddress: fatherCompanyAddress,
                motherCompanyAddress: motherCompanyAddress,
                fatherPhone: fatherPhone,
                motherPhone: motherPhone,
                fatherEmail: fatherEmail,
                motherEmail: motherEmail,
                fatherAddress: fatherAddress,
                motherAddress: motherAddress,
                motherAttendedInstitution: motherAttendedInstitution,
                fatherAttendedInstitution: fatherAttendedInstitution,
                fatherDeceased: fatherDeceased,
                motherDeceased: motherDeceased,
                isFatherEmployee:isFatherEmployee,
                isMotherEmployee:isMotherEmployee,
                fatherIdNumber:fatherIdNumber,
                motherIdNumber:val
              })
            }}




            disableAll={false}
            errRelation=""
            errPrefix={validationError.motherPrefix ? validationError.motherPrefix : ''}
            errFName={validationError.motherFName ? validationError.motherFName : ''}
            errMName={validationError.motherMName ? validationError.motherMName : ''}
            errLName={validationError.motherLName ? validationError.motherLName : ''}
            errProfession={validationError.motherProfession ? validationError.motherProfession : ''}
            errMobile={validationError.motherPhone ? validationError.motherPhone : ''}
            errEmail={validationError.motherEmail ? validationError.motherEmail : ''}
            errIdNumber={validationError.motherIdNumber ? validationError.motherIdNumber : ''}
          />
       
        </div>
        <button className="save" onClick={() => { this.props.onSave() }}>Next</button>

      </div>
    )
  }
}
ParentsInformation.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  fatherInfo: PropTypes.object,
  motherInfo: PropTypes.object,
  collectState: PropTypes.func,
  error: PropTypes.object,
  getDefaultValue: PropTypes.func,
  fatherId: PropTypes.number.isRequired,
  motherId: PropTypes.number.isRequired
}
